/**
 * Permission constants for the frontend
 * Mirrors the backend permission constants for consistency
 */

export const PERMISSION_RESOURCES = {
  // Core resources
  USER: 'users',
  CLIENT: 'clients',
  BRAND: 'brands',
  CONTENT: 'content',
  CAMPAIGN: 'campaigns',
  PROJECT: 'projects',
  PROJECT_TEMPLATE: 'project_templates',
  TASK: 'tasks',
  SECTION: 'sections',
  MILESTONE: 'milestones',
  
  // Form resources
  FORM: 'forms',
  FORM_SUBMISSION: 'form_submissions',
  
  // Workflow resources
  WORKFLOW: 'workflows',
  
  // Financial resources
  FINANCE: 'finances',
  INVOICE: 'invoices',
  EXPENSE: 'expenses',
  VENDOR: 'vendors',
  
  // Reporting resources
  ANALYTICS: 'analytics',
  REPORT: 'reports',
  ACTIVITY: 'activities',
  
  // System resources
  SETTING: 'settings',
  NOTIFICATION: 'notifications',
  TAX_CONFIG: 'tax_config',
  ROLE: 'roles',
  
  // Lead management
  LEAD: 'leads',
  
  // Planning
  SOSTAC: 'sostac',
  
  // Document management
  PDF: 'pdfs',
  
  // HR Resources
  EMPLOYEE: 'employees',
  LEAVE: 'leaves',
  PERFORMANCE: 'performance',
  PAYROLL: 'payroll',
  ATTENDANCE: 'attendance',
  GOALS: 'goals',
  RECRUITMENT: 'recruitment',
  ORGANIZATION: 'organization',
  
  // My Tasks View As Feature
  MYTASKS: 'mytasks',
  
  // Pricing Calculator
  PRICING_CONFIG: 'pricing_config',
  QUOTE: 'quotes',
  
  // Time Tracking Analytics
  TIME_TRACKING_ANALYTICS: 'time_tracking_analytics',
  
  // Global Calendar Feature
  GLOBAL_CALENDAR: 'global_calendar',
  
  // Workflow Automation Feature
  WORKFLOW_AUTOMATION: 'workflow_automation'
};

export const PERMISSION_ACTIONS = {
  CREATE: 'create',
  READ: 'read',
  UPDATE: 'update',
  DELETE: 'delete',
  APPROVE: 'approve',
  ASSIGN: 'assign',
  EXPORT: 'export',
  IMPORT: 'import',
  PUBLISH: 'publish',
  SHARE: 'share',
  VIEW_ANALYTICS: 'view_analytics',
  MANAGE_CATEGORIES: 'manage_categories',
  // HR specific actions
  MANAGE: 'manage',
  REVIEW: 'review',
  VALIDATE: 'validate',
  PROCESS: 'process',
  SUBMIT: 'submit',
  CALIBRATE: 'calibrate',
  ONBOARD: 'onboard',
  INTERVIEW: 'interview',
  SCREEN: 'screen',
  COMMUNICATE: 'communicate',
  VIEW_TEAM: 'view_team',
  APPROVE_OVERTIME: 'approve_overtime',
  APPROVE_TIMESHEET: 'approve_timesheet',
  REPORTS: 'reports',
  VIEW_CREDENTIALS: 'view_credentials',
  // My Tasks View As Feature
  VIEW_AS: 'view_as',
  VIEW_AS_MANAGE: 'view_as_manage',
  // Workflow Automation
  EXECUTE: 'execute'
};

export const PERMISSION_SCOPES = {
  OWN: 'own',
  ASSIGNED: 'assigned',
  TEAM: 'team',
  PROJECT: 'project',
  BRAND: 'brand',
  CLIENT: 'client',
  ORGANIZATION: 'organization',
  ALL: 'all'
};